import { router } from 'expo-router';
import { StyleSheet, View } from 'react-native';
import { Divider } from 'react-native-paper';

import { useGetNonProfitLightRatingQuestions } from '@/api/hooks/nonProfitOrgHooks';
import { NonProfitOrgProfileResponse } from '@/api/models/nonProfitOrgModels';
import BrandedButton from '@/components/buttons/BrandedButton';
import { i18n } from '@/utils/i18n';

const QuestionItem = ({
  canEdit,
  npoId,
  name
}: {
  canEdit: boolean;
  npoId: NonProfitOrgProfileResponse['id'];
  name: NonProfitOrgProfileResponse['name'];
}) => {
  const { data: questionOptions } = useGetNonProfitLightRatingQuestions();

  const onPressViewAll = () => {
    if (canEdit) {
      router.navigate('/edit/npoLightRatingQuestions');
    } else {
      router.navigate({
        pathname: '/questions/npoLightRatingQuestions',
        params: { npoId, name, questionsOptions: JSON.stringify(questionOptions) }
      });
    }
  };

  return (
    <>
      <View style={styles.container}>
        <BrandedButton
          onPress={onPressViewAll}
          borderWidth={1}
          backGroundColor="white"
          borderColor="black"
          textStyles={{ color: 'black' }}>
          {i18n.t('npo_details.insights.qa_all_button')}
        </BrandedButton>
      </View>
      <Divider />
    </>
  );
};

export default QuestionItem;

const styles = StyleSheet.create({
  container: {
    rowGap: 15
  }
});
